import { render, staticRenderFns } from "./InstagramFilledIcon.vue?vue&type=template&id=1072ba04&scoped=true"
var script = {}
import style0 from "./InstagramFilledIcon.vue?vue&type=style&index=0&id=1072ba04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1072ba04",
  null
  
)

export default component.exports